(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Desktop top-level dropdown delayed close fix.

    Scope:
    - only desktop: min-width 990px
    - only top-level header menu items:
      .header__inline-menu > ul > li > header-menu
    - does not touch nested details directly
    - does not affect mobile drawer
    - does not change labels, links, structure, products, collections, checkout, or countdown
  */
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const closeDelay = 850;
    const timers = new WeakMap();

    const getTopLevelHeaderMenus = () => {
      return document.querySelectorAll('.header__inline-menu > ul > li > header-menu');
    };

    const getTopLevelDetails = (headerMenu) => {
      return headerMenu.querySelector(':scope > details');
    };

    const getTopLevelSummary = (headerMenu) => {
      return headerMenu.querySelector(':scope > details > summary');
    };

    const clearCloseTimer = (headerMenu) => {
      const timer = timers.get(headerMenu);

      if (!timer) return;

      window.clearTimeout(timer);
      timers.delete(headerMenu);
    };

    const closeTopLevelMenu = (headerMenu) => {
      const details = getTopLevelDetails(headerMenu);
      const summary = getTopLevelSummary(headerMenu);

      if (!details) return;

      details.removeAttribute('open');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    };

    const scheduleClose = (headerMenu) => {
      clearCloseTimer(headerMenu);

      const timer = window.setTimeout(() => {
        if (!desktopQuery.matches) return;

        /*
          If the cursor returned to the top-level menu or its submenu,
          do not close it.
        */
        if (headerMenu.matches(':hover')) return;

        closeTopLevelMenu(headerMenu);
        timers.delete(headerMenu);
      }, closeDelay);

      timers.set(headerMenu, timer);
    };

    const bindTopLevelDropdownDelay = () => {
      getTopLevelHeaderMenus().forEach((headerMenu) => {
        if (headerMenu.dataset.desktopDropdownDelayBound === 'true') return;

        const details = getTopLevelDetails(headerMenu);
        const summary = getTopLevelSummary(headerMenu);

        if (!details || !summary) return;

        headerMenu.dataset.desktopDropdownDelayBound = 'true';

        /*
          Capture mouseleave on the top-level header-menu wrapper.
          This blocks the theme's instant close while still allowing
          keyboard/click behavior to work normally.
        */
        headerMenu.addEventListener(
          'mouseleave',
          (event) => {
            if (!desktopQuery.matches) return;

            event.stopImmediatePropagation();
            scheduleClose(headerMenu);
          },
          true
        );

        /*
          Also capture mouseleave on the top-level details itself.
          This is still top-level only because details is selected via :scope.
        */
        details.addEventListener(
          'mouseleave',
          (event) => {
            if (!desktopQuery.matches) return;

            event.stopImmediatePropagation();
            scheduleClose(headerMenu);
          },
          true
        );

        headerMenu.addEventListener(
          'mouseenter',
          () => {
            if (!desktopQuery.matches) return;

            clearCloseTimer(headerMenu);
            getTopLevelHeaderMenus().forEach((otherMenu) => {
              if (otherMenu === headerMenu) return;
              clearCloseTimer(otherMenu);
              closeTopLevelMenu(otherMenu);
            });
          },
          true
        );

        details.addEventListener(
          'mouseenter',
          () => {
            if (!desktopQuery.matches) return;

            clearCloseTimer(headerMenu);
          },
          true
        );

        summary.addEventListener('focus', () => {
          clearCloseTimer(headerMenu);
        });

        summary.addEventListener('mouseenter', () => {
          if (!desktopQuery.matches) return;

          clearCloseTimer(headerMenu);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindTopLevelDropdownDelay);
    } else {
      bindTopLevelDropdownDelay();
    }

    window.addEventListener('load', bindTopLevelDropdownDelay);

    desktopQuery.addEventListener('change', () => {
      if (desktopQuery.matches) {
        bindTopLevelDropdownDelay();
        return;
      }

      getTopLevelHeaderMenus().forEach((headerMenu) => {
        clearCloseTimer(headerMenu);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
